// src/modules/app-views/ticket-events/pages/Document/components/TicketEventsDocumentCardHeaderColumn2.jsx
// Card Header Column 2: remaining/total tickets + sale start + sale end
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { CalendarOutlined, FieldTimeOutlined, TeamOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import dayjs from 'dayjs';

const TicketEventsDocumentCardHeaderColumn2 = ({ ...record }) => {
  const sold = record?.soldTickets || 0;
  const total = record?.totalTickets || 0;
  const remaining = total - sold;

  const saleStartDate = record?.saleStartDate
    ? dayjs(record.saleStartDate).format('DD/MM/YY HH:mm')
    : '-';

  const saleEndDate = record?.saleEndDate
    ? dayjs(record.saleEndDate).format('DD/MM/YY HH:mm')
    : '-';

  const items = [
    {
      key: 'tickets',
      icon: <TeamOutlined />,
      label: `${remaining} / ${total}`,
      tooltipText: translateX('remaining_tickets'),
      tooltipPlacement: 'right',
    },
    {
      key: 'saleStart',
      icon: <CalendarOutlined />,
      label: saleStartDate,
      tooltipText: translateX('sale_start'),
      tooltipPlacement: 'right',
    },
    {
      key: 'saleEnd',
      icon: <FieldTimeOutlined />,
      label: saleEndDate,
      tooltipText: translateX('sale_end'),
      tooltipPlacement: 'right',
    },
  ];

  return <SimpleColumn items={items} />;
};

export default TicketEventsDocumentCardHeaderColumn2;
